export default __webpack_public_path__ + "static/media/article-01.efff28bc.jpg";